import { render, staticRenderFns } from "./AcknowledgeRating.vue?vue&type=template&id=49a1f422&scoped=true"
import script from "./AcknowledgeRating.vue?vue&type=script&lang=js"
export * from "./AcknowledgeRating.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgeRating.vue?vue&type=style&index=0&id=49a1f422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1f422",
  null
  
)

export default component.exports